(function (send) {

  function setQuizCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  function buildQuizAnswer(raw) {
    const rawJSON = JSON.parse(raw);
    let result = '';

    for (const [key, value] of Object.entries(rawJSON.answers)) {
      result += `${key.trim()}:${value.join('-').trim()},`;
    }

    return result.replace(/,\s*$/, "");
  }

  XMLHttpRequest.prototype.send = function (body) {
    this.addEventListener('readystatechange', function () {
      if (this.responseURL.indexOf('api.quizkitapp.com/api/v1/quizzes') !== -1 && this.__sentry_xhr__.method === 'POST') {
        if (body) {
          const bodyObject = JSON.parse(body);
          if (bodyObject.hasOwnProperty('answers')) {
            localStorage.setItem('quiz-requests', buildQuizAnswer(body));
            localStorage.setItem('quiz-responses', this.responseText);
            setQuizCookie('quiz-requests', buildQuizAnswer(body), 365);
            setQuizCookie('quiz-responses', this.responseText, 365);
          }
        }
      }
    });

    send.call(this, body);
  };

})(XMLHttpRequest.prototype.send); 